import BaseNodeModel from "../BaseNodeModel";
import React from "react";

export default class SystemAnnotationDataModel extends BaseNodeModel {
    constructor(id, name, text) {
        super(name, 0, 0, null, id);
        this.props.nodeTypeName = "System Annotation";
        this.props.config.text = text;
    }

    setConfig(key, value) {
        window.apm.setDialogConfig(this.id, key, value);
        super.setConfig(key, value);
    }

    getConfigViews() {
        return [
            {type: "Textarea", label: "Text", key: "text"}
        ];
    }
}